
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"11","height":"17","viewBox":"0 0 11 17","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.5 0C8.53268 0 11 2.65085 11 5.90912C11 10.0044 5.49459 17 5.49459 17C5.49459 17 0 9.80302 0 5.90912C0 2.65085 2.46723 0 5.5 0ZM3.84054 7.63931C4.29811 8.13082 4.89901 8.37663 5.5 8.37663C6.1009 8.37663 6.70198 8.13082 7.15937 7.63931C8.07442 6.65629 8.07442 5.05673 7.15937 4.07361C6.71628 3.59735 6.12687 3.33505 5.5 3.33505C4.87313 3.33505 4.28382 3.59746 3.84054 4.07361C2.92548 5.05673 2.92548 6.65629 3.84054 7.63931Z"}})])
          )
        }
      }
    